import Model, { belongsTo, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { RevenueInsightSegmentationValue } from 'lumen/models';

export default class RevenueInsightKpisRequest extends Model {
  [Type] = 'revenue-insight/kpis-request' as const;

  @belongsTo('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare all: RevenueInsightSegmentationValue;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare impact_date: HasMany<RevenueInsightSegmentationValue>;
}
